import { Log, UserManager, WebStorageStateStore } from 'oidc-client';
var idsrvAuthorityEl = document.getElementById('IdsrvAuthority');
var idsrvAuthority = idsrvAuthorityEl && idsrvAuthorityEl.value;
Log.logger = console;
if (process.env.NODE_ENV !== 'development') {
    Log.level = Log.WARN;
}
var userManager = new UserManager({
    authority: idsrvAuthority,
    client_id: 'graphql',
    redirect_uri: "".concat(window.location.origin, "/graphql/login-callback"),
    post_logout_redirect_uri: "".concat(window.location.origin, "/graphql/logout-callback"),
    response_type: 'code',
    scope: 'openid profile graphql',
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: "".concat(window.location.origin, "/graphql/silent-callback"),
});
export default userManager;
